export const SAVECHAT = "SAVECHAT";

export const saveChat = (value) => ({
  type: SAVECHAT,
  payload: value
});